import {useAddShopCar, useSubShopCar} from "../../../../api/orderShopcarDetail";

export default function CountControl(props) {
  const {
    count,
    maxCount = 99,
    goods, // 只有在购物车中会传这个值，加减的时候会触发add sub 接口
    addCount,
    subCount,
    iconColor,
    inputBgColor
  } = props;
  
  let query = {
    itemId: goods?.itemId,
    itemSkuId: goods?.itemSkuId,
    quantity: 1,
  };
  
  const { addHandle } = useAddShopCar();
  const { subHandle } = useSubShopCar();
  
  const add = () => {
    if (count >= maxCount) return;
    if (goods) addHandle(query);
    addCount('add');
  };
  
  const sub = () => {
    if (count === 1) return;
    if (goods) subHandle(query);
    subCount('sub');
  };
  
  const countHandle = (e) => {
    console.log(e.target.value, 'eee');
  };
  
  return (
    <div className="rounded-full border border-[#d4d4d4] flex p-[2px] md:py-[5px] text-center items-center">
      <a className="flex-1 px-[10px] cursor-pointer" onClick={sub}>
        <i className="iconfont icon-sub text-[16px]"
           style={{
             opacity: count === 1 ? 0.4 : 1,
             color: iconColor ? iconColor : '#333',
           }}/>
      </a>
      <input className="flex-1 text-[16px] mdmax:text-[13px] w-[45px] mdmax:w-[30px] text-center"
             onChange={countHandle}
             readOnly
             type="number"
             style={{
               backgroundColor: inputBgColor,
               color: iconColor ? iconColor : '#333'
             }}
             value={count}/>
      <a className="flex-1 px-[10px] cursor-pointer" onClick={add}>
        <i className="iconfont icon-plus text-[16px]"
           style={{
             opacity: count === maxCount ? 0.4 : 1,
             color: iconColor ? iconColor : '#333'
           }}/>
      </a>
    </div>
  );
}
